export default __webpack_public_path__ + "static/media/mockup-tablet.61b37f23.webp";